import { useFormContext } from 'react-hook-form';
import { UseWorkFormTabResetResult } from './work-form-create-tabs.types';
import { WorkFormContext } from '../../work-form.types';
import { MULTI_DAY_WORK_FORM_FIELDS, WorkFormCreateTab } from '../multi-day-work.types';

const resetSingleDayTabFields = (
  setValue: ReturnType<typeof useFormContext<WorkFormContext>>['setValue']
) => {
  setValue('startDate', undefined);
  setValue('endDate', undefined);
  setValue('startTime', undefined);
  setValue('endTime', undefined);
  setValue('breakMinutes', undefined);
  setValue('additionalCreateDates', []);
};

const resetMultiDayTabFields = (
  setValue: ReturnType<typeof useFormContext<WorkFormContext>>['setValue']
) => {
  setValue(MULTI_DAY_WORK_FORM_FIELDS.multiDayDates, []);
  setValue(MULTI_DAY_WORK_FORM_FIELDS.multiDayDayBlocks, []);
};

export const changeWorkFormCreateTab = (
  setValue: ReturnType<typeof useFormContext<WorkFormContext>>['setValue'],
  currentTab: WorkFormCreateTab,
  newTab: WorkFormCreateTab
) => {
  if (newTab === currentTab) {
    return;
  }

  if (newTab === 'multi-day') {
    resetSingleDayTabFields(setValue);
  } else {
    resetMultiDayTabFields(setValue);
  }

  setValue(MULTI_DAY_WORK_FORM_FIELDS.createTab, newTab);
};

export const useWorkFormTabReset = (): UseWorkFormTabResetResult => {
  const { watch, setValue } = useFormContext<WorkFormContext>();
  const createTab = watch(MULTI_DAY_WORK_FORM_FIELDS.createTab) ?? 'single-day';

  const handleTabChange = (_event: React.SyntheticEvent, newTab: WorkFormCreateTab) => {
    changeWorkFormCreateTab(setValue, createTab, newTab);
  };

  return { createTab, handleTabChange };
};
